export default __webpack_public_path__ + "static/wave-6d95f79ffb999873b97e8d33642b0302.svg";